import React, { useState } from 'react';
import { FaBook, FaChevronDown, FaChevronRight, FaCheckCircle, FaRegCircle, FaFolder, FaFolderOpen } from 'react-icons/fa';

const NotesSidebar = ({ courses, selectedTopicId, onTopicSelect, onFolderSelect }) => {
    const [expandedItems, setExpandedItems] = useState({});

    const toggleExpand = (id) => {
        setExpandedItems(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const renderTree = (items, level = 0) => {
        if (!items || !Array.isArray(items)) {
            return null;
        }
        
        return items.map(item => {
            if (!item) return null;
            
            const hasChildren = item.children && Array.isArray(item.children) && item.children.length > 0;
            const isExpanded = expandedItems[item.id];
            const isFolder = item.content_type === 'folder';
            const isSelected = selectedTopicId === item.id;
            
            return (
                <div key={item.id || Math.random()} className="notes-tree-item" style={{ marginLeft: `${level * 16}px` }}>
                    <div 
                        className={`notes-tree-node ${isSelected ? 'active' : ''}`}
                        onClick={() => {
                            if (isFolder) {
                                toggleExpand(item.id);
                                if (onFolderSelect) onFolderSelect(item);
                            } else {
                                onTopicSelect(item);
                            }
                        }}
                    >
                        <div className="notes-tree-node-content">
                            {hasChildren && (
                                <span className="notes-tree-chevron">
                                    {isExpanded ? <FaChevronDown size={10} /> : <FaChevronRight size={10} />}
                                </span>
                            )}
                            {!hasChildren && <span className="notes-tree-placeholder" />}
                            
                            <span className="notes-tree-icon">
                                {isFolder ? (
                                    isExpanded ? <FaFolderOpen className="text-warning" /> : <FaFolder className="text-warning" />
                                ) : (
                                    item.is_completed ? <FaCheckCircle className="text-success" /> : <FaRegCircle className="text-muted" />
                                )}
                            </span>
                            
                            <span className="notes-tree-title" title={item.title || 'Untitled'}>
                                {item.title || 'Untitled'}
                            </span>
                            
                            {isFolder && hasChildren && (
                                <span className="notes-tree-count">({item.children.length})</span>
                            )}
                        </div>
                    </div>
                    
                    {hasChildren && isExpanded && (
                        <div className="notes-tree-children">
                            {renderTree(item.children, level + 1)}
                        </div>
                    )}
                </div>
            );
        });
    };

    return (
        <div className="notes-sidebar-wrapper">
            <div className="notes-sidebar">
                <div className="notes-sidebar-header">
                    <FaBook className="notes-sidebar-icon" />
                    <h3>Notes Library</h3>
                </div>
                
                <div className="notes-sidebar-content">
                    {courses.length === 0 ? (
                        <div className="notes-sidebar-empty">
                            <p>No notes available yet.</p>
                            <small>Check back later for new content.</small>
                        </div>
                    ) : (
                        courses.map(course => (
                            <div key={course.course_id || Math.random()} className="notes-course-section">
                                <div className="notes-course-header">
                                    <FaFolder className="text-primary me-2" />
                                    <span className="notes-course-name">{course.course_name || 'Untitled Course'}</span>
                                </div>
                                <div className="notes-course-content">
                                    {renderTree(course.structure || [])}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default NotesSidebar;